export default __webpack_public_path__ + "static/media/psa-vollversorgung.be4d069b.webp";